import React, { useState } from 'react';
import { Box, Typography, Button, Container, Grid, useTheme, useMediaQuery, InputAdornment, TextField, IconButton } from '@mui/material';
import { SearchIcon, PlusIcon, XIcon, StoreIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import SubAgentsTable from '../components/SubAgentsTable';
import SubAgentFormDrawer from '../components/SubAgentFormDrawer';
interface SubAgentsProps {
  onLogout: () => void;
}
const SubAgents: React.FC<SubAgentsProps> = ({
  onLogout
}) => {
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [subAgentDrawerOpen, setSubAgentDrawerOpen] = useState(false);
  const [editSubAgent, setEditSubAgent] = useState<any>(null);
  const [searchQuery, setSearchQuery] = useState('');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleAddSubAgent = () => {
    setEditSubAgent(null);
    setSubAgentDrawerOpen(true);
  };
  const handleEditSubAgent = (subAgent: any) => {
    setEditSubAgent(subAgent);
    setSubAgentDrawerOpen(true);
  };
  const handleCloseSubAgentDrawer = () => {
    setSubAgentDrawerOpen(false);
    setEditSubAgent(null);
  };
  const handleSaveSubAgent = (subAgentData: any) => {
    // In a real app, this would save the sub agent data to the backend
    console.log('Save sub agent', subAgentData);
    setSubAgentDrawerOpen(false);
    // Show success toast (would be implemented with a toast library)
  };
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };
  const clearSearch = () => {
    setSearchQuery('');
  };
  const handleManageUsers = (subAgentId: string) => {
    // Use React Router navigation instead of window.location
    navigate(`/sub-agent-users?subAgent=${subAgentId}`);
  };
  return <Box sx={{
    display: 'flex',
    minHeight: '100vh',
    backgroundColor: '#F8FAFC'
  }} data-id="element-5018">
      <TopBar onMenuClick={handleDrawerToggle} onLogout={onLogout} data-id="element-5019" />
      <Sidebar open={mobileOpen} onClose={handleDrawerToggle} activePage="sub-agents" data-id="element-5020" />
      <Box component="main" sx={{
      flexGrow: 1,
      py: 2,
      px: 1,
      width: {
        sm: `calc(100% - ${240}px)`
      },
      ml: 0,
      mt: 8
    }} data-id="element-5021">
        <Container maxWidth="xl" data-id="element-5022">
          {/* Header */}
          <Grid container spacing={2} alignItems="center" sx={{
          mb: 3
        }} data-id="element-5023">
            <Grid item xs={12} md={6} data-id="element-5024">
              <Box sx={{
              display: 'flex',
              alignItems: 'center'
            }} data-id="element-5025">
                <StoreIcon size={24} color="#0EA5E9" data-id="element-5026" />
                <Typography variant="h5" component="h1" sx={{
                ml: 1.5,
                fontWeight: 600
              }} data-id="element-5027">
                  Sub Agents
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6} data-id="element-5028">
              <Box sx={{
              display: 'flex',
              gap: 2,
              flexWrap: 'wrap',
              justifyContent: {
                xs: 'flex-start',
                md: 'flex-end'
              }
            }} data-id="element-5029">
                <Button variant="contained" startIcon={<PlusIcon size={18} data-id="element-5031" />} onClick={handleAddSubAgent} data-id="element-5030">
                  Add Sub Agent
                </Button>
              </Box>
            </Grid>
            <Grid item xs={12} data-id="element-5032">
              <TextField fullWidth placeholder="Search sub agents by name, contact person, or email..." variant="outlined" value={searchQuery} onChange={handleSearch} InputProps={{
              startAdornment: <InputAdornment position="start" data-id="element-5034">
                      <SearchIcon size={20} color="#475569" data-id="element-5035" />
                    </InputAdornment>,
              endAdornment: searchQuery ? <InputAdornment position="end" data-id="element-5036">
                      <IconButton size="small" onClick={clearSearch} data-id="element-5037">
                        <XIcon size={18} data-id="element-5038" />
                      </IconButton>
                    </InputAdornment> : null
            }} data-id="element-5033" />
            </Grid>
          </Grid>
          {/* Sub Agents Table */}
          <SubAgentsTable onEditSubAgent={handleEditSubAgent} onManageUsers={handleManageUsers} searchQuery={searchQuery} data-id="element-5039" />
          {/* Sub Agent Form Drawer */}
          <SubAgentFormDrawer open={subAgentDrawerOpen} subAgent={editSubAgent} onClose={handleCloseSubAgentDrawer} onSave={handleSaveSubAgent} data-id="element-5040" />
        </Container>
      </Box>
    </Box>;
};
export default SubAgents;